import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/smooth";
import { Reveal } from "@/components/Reveal";

export const CtaFinal = ({ title = "Il tuo canone migliore è a pochi minuti da qui", subtitle = "Compila il modulo: ti richiama un consulente dedicato con la proposta più conveniente dello stock. Gratis, senza impegno." }) => (
  <section className="relative overflow-hidden bg-xmove-orange py-16 lg:py-20 grain" data-testid="cta-final">
    <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
      <Reveal>
        <h2 className="text-balance font-display text-3xl font-bold text-white sm:text-4xl lg:text-5xl">{title}</h2>
        <p className="mx-auto mt-4 max-w-xl text-base text-white/85 md:text-lg">{subtitle}</p>
        <button
          onClick={() => scrollToId("preventivo")}
          data-testid="cta-final-btn"
          className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 font-display text-base font-bold text-xmove-orange shadow-lift transition-all hover:scale-[1.03] active:scale-[0.98]"
        >
          Richiedi il preventivo gratuito
          <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </button>
      </Reveal>
    </div>
  </section>
);
